
import { useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tooltip } from '@bwoty-web/styleguide';
import { useOnClickOutside } from '../../hooks/useOnClickOutside';
import './toolPanelReminder.scss';

const ToolPanelReminder = ({ close, labels }) => {
  const { filterReminderPrefix, filterReminder } = labels;
  const ref = useRef();
  useOnClickOutside(ref, close);

  return (
    <div className='vf-tool-panel-reminder'>
      <div ref={ref}>
        <Tooltip
          arrowVerticalPosition="bottom"
          className="vf-tool-panel-reminder__tooltip"
          onClose={close}
        >
          <b>{filterReminderPrefix} </b><span>{filterReminder}</span>
        </Tooltip>
      </div>
    </div>
  )
}

ToolPanelReminder.propTypes = {
  close: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    filterReminder: PropTypes.string,
    filterReminderPrefix: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = ({ attributeCollection }) => {
  const labels = {
    filterReminder: attributeCollection.filterReminder,
    filterReminderPrefix: attributeCollection.filterReminderPrefix,
  }
  return {
    labels,
  };
};

export default connect(mapStateToProps)(ToolPanelReminder);
